import { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft } from "lucide-react";
import { adminApi } from "@/lib/adminApi";
import { Seo } from "@/components/Seo";

export default function AdminLogin() {
  const location = useLocation();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [denied, setDenied] = useState(location.state?.error || "");

  useEffect(() => {
    adminApi.get("/auth/me")
      .then((r) => {
        if (r.data.is_admin) navigate("/admin/inbox", { replace: true, state: { user: r.data } });
        else setDenied(`Signed in as ${r.data.email}, but this inbox is restricted to the Captain's Cut team.`);
      })
      .catch(() => {})
      .finally(() => setChecking(false));
  }, [navigate]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/inbox";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#070A0F] text-[#F7F8F9] grain flex items-center justify-center px-5" data-testid="admin-login-page">
      <Seo title="Team Sign-In — Captain's Cut" description="Private sign-in for the Captain's Cut production team." path="/admin" noindex />
      <div className="w-full max-w-md border border-[#D4AF37]/30 bg-[#0B111B] p-8 md:p-10">
        <p className="text-[10px] tracking-[0.45em] uppercase text-[#D4AF37]">Captain's Cut · Crew Only</p>
        <h1 className="font-display text-2xl md:text-3xl tracking-[0.08em] text-[#F5F3EF] mt-3">APPLICATIONS INBOX</h1>
        <p className="text-sm text-[#94A3B8] leading-relaxed mt-4">
          Private review of Captain, First Mate and Yacht applications plus charter requests. Access is limited to the
          production team's Google account.
        </p>
        {denied && (
          <p className="mt-5 text-xs text-[#F5B7B1] border border-[#F5B7B1]/30 bg-[#F5B7B1]/5 p-3" data-testid="admin-login-denied">{denied}</p>
        )}
        <button onClick={signIn} disabled={checking}
          className="mt-8 w-full flex items-center justify-center gap-3 bg-[#D4AF37] text-[#070A0F] font-display text-sm tracking-[0.25em] py-4 hover:bg-[#F3E08A] transition-colors duration-300 disabled:opacity-60"
          data-testid="admin-google-signin-btn">
          <ShieldCheck size={16} /> {checking ? "CHECKING SESSION…" : "SIGN IN WITH GOOGLE"}
        </button>
        <Link to="/" className="mt-6 inline-flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase text-[#94A3B8] hover:text-[#E8C15A] transition-colors" data-testid="admin-back-home">
          <ArrowLeft size={12} /> Back to the site
        </Link>
      </div>
    </div>
  );
}
